import { CdkScrollable } from '@angular/cdk/scrolling';
import { AsyncPipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BuyerOffersService } from '../../../buyer-modules/account/my-offers/_services/buyer-offers.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { finalize } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { NumbersOnlyDirective } from 'src/app/Shared/directives/numbersOnly/numbers-only.directive';
import { CurrencySymbolPipe } from 'src/app/Shared/_pipes/currency-symbol/currency-symbol.pipe';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';

@Component({
    selector: 'app-make-offer-dialog',
        standalone: true,
imports: [ReactiveFormsModule, FormsModule, MatFormField, MatInputModule, MatSuffix, MatDialogClose, MatProgressSpinner, NumbersOnlyDirective, CurrencySymbolPipe, TranslatePipe, AsyncPipe],
    templateUrl: './make-offer-dialog.component.html',
    styleUrl: './make-offer-dialog.component.scss',
    providers: [CurrencySymbolPipe]
})
export class MakeOfferDialogComponent {
  auction_item_id: any;
  parent_offer_id: number = 0; // Default to 0 if not specified
  offerForm: FormGroup;
  isSubmitting: boolean = false;
  currency: any;
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<MakeOfferDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private buyerOfferService: BuyerOffersService,
    private toastService: ToastService,
    private fb: FormBuilder,
    public localeService: LocaleService
  ) {
    this.auction_item_id = data.auction_item_id;
    this.parent_offer_id = data.parent_offer_id || 0;
    this.currency = data?.currencyLocal.currency;
    // Initialize form
    this.offerForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
      notes: [''],
    });
  }

  ngOnInit(): void {
    // Any additional initialization logic
  }

  // Getter for easier form control access in the template
  get amount() {
    return this.offerForm.get('amount');
  }

  submitOffer(): void {
    this.toastService.clear();
    if (this.offerForm.invalid) {
      // Mark all fields as touched to trigger validation display
      this.offerForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const offerData = {
      amount: this.offerForm.value.amount,
      notes: this.offerForm.value.notes,
      auction_item_id: this.auction_item_id,
      parent_offer_id: '',
    };

    this.buyerOfferService
      .makeOffer(offerData)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe({
        next: (response) => {
          this.toastService.showSuccess(response?.message);
          this.dialogRef.close(true); // Close with success result
        },
        error: (error) => {
          console.error('Error submitting offer:', error);
          this.toastService.showError(
            error?.error?.error ||
                            'Failed to submit offer'
          );
        },
      });
  }
}
